import { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/project-configuration/context';
import { useSearchRooms } from 'pages/common/hooks/use-search-rooms.hook';

export const useGetRooms = () => {
  const data = useContext(DataContext);
  const apiMethods = data!.api;

  useSearchRooms({
    apiMethods,
    isFloor: true,
  });
};
